import React, { useState, useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { useTheme } from "@material-ui/styles";
import { useMediaQuery } from "@material-ui/core";
import { Theme } from "../../../theme";
import useInterval from "../../../utils/functions/useInterval";
import CameraCard from "./CameraCard";

const DEPLOYMENT_IDS = [
  {
    ids: [3, 4],
    location: "West Circular Quay",
    weights: { m: 1, d: 1, f: 1 },
    riskWeights: { m: 3, d: 3, f: 1 },
    defaults: { m: 0.5, d: 1, f: 1 },
  },
  // {
  //   ids: [16],
  //   location: "East Circular Quay",
  //   weights: { m: 1, d: 1, f: 1 },
  //   riskWeights: { m: 1, d: 1, f: 1 },
  //   defaults: { m: 0.5, d: 0, f: 0 },
  // },
  {
    ids: [14],
    location: "SOPA 1",
    weights: { m: 1, d: 1, f: 1 },
    riskWeights: { m: 1, d: 1, f: 1 },
    defaults: { m: 0.5, d: 0, f: 0 },
  },
  {
    ids: [15],
    location: "SOPA 2",
    weights: { m: 1, d: 1, f: 1 },
    riskWeights: { m: 1, d: 1, f: 1 },
    defaults: { m: 0.5, d: 0, f: 0 },
  },
  // {
  //   ids: [13],
  //   location: "Test Office",
  //   // location: "Circular Quay",
  //   weights: { m: 1, d: 1, f: 1 },
  //   riskWeights: { m: 1, d: 1, f: 1 },
  //   defaults: { m: 0.5, d: 0, f: 0 },
  // },
];
// const TIMESTAMP = new Date("2019-06-08");
const TIMESTAMP = new Date("2019-06-08");

const StyledSection = styled.section`
  padding: 12px;

  @media screen and (min-width: 600px) {
    padding-top: 16px;
  }

  ${({ theme }: { theme: Theme }) => {
    return css``;
  }};
`;

export interface CameraContainerProps {}

//Layout is determined here
const CameraContainer: React.FC<CameraContainerProps> = () => {
  const theme: Theme = useTheme();
  const [deploymentIds, setDeploymentIds] = useState(DEPLOYMENT_IDS);
  //   const mdUp = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <StyledSection theme={theme}>
        {deploymentIds.map(v => (
          <CameraCard
            defaults={v.defaults}
            riskWeights={v.weights}
            weights={v.weights}
            timestamp={TIMESTAMP}
            deploymentIds={v.ids}
            key={v.location}
            location={v.location}
          ></CameraCard>
        ))}
      </StyledSection>
    </>
  );
};

export default CameraContainer;
